/**
 * UsuarioGrupoTemplate — vínculo Usuario x Grupo (ancora o JWT).
 *
 * Copiado de hay-hotspot/assets/reactweb/src/pages/Auth/UsuarioGrupo/UsuarioGrupoTemplate.js
 * (Fase 3.2). Reincluído o `filtro` condicional do campo `grupo` (removido por engano nesta
 * cópia originalmente) — LinkInsight usa o mesmo mecanismo de `permiteacessogeral` do
 * hay-hotspot (ver ConsultaService.js: sem filtro de publicacao quando a sessão acessa por uma
 * publicação de acesso geral), então o dropdown de Grupo também mistura grupos de todos os
 * tenants nesse caso sem o filtro (achado em produção no hay-hotspot, especificações 183/186).
 */
import React, { Component } from 'react';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { RelatedEntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelDropDown } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import UsuarioGrupo from '../../../models/UsuarioGrupo';
import { Usuario } from 'hay-core-react';
import Grupo from '../../../models/Grupo';

const model = {
  usuario: {
    exibir: 'main.usuariogrupo.usuario',
    visivel: true,
    tipo: 'relacao',
    camporelacao: 'nome',
    entidade: 'usuario.entidade',
    template: 'usuario.template',
    validacao: { obrigatorio: true },
  },
  grupo: {
    exibir: 'main.usuariogrupo.grupo',
    visivel: true,
    tipo: 'relacao',
    entidade: 'grupo.entidade',
    template: 'grupo.template',
    camporelacao: 'nome',
    validacao: { obrigatorio: true },
    // Publicacao só existe em `state.model` pra quem acessou por uma publicação de acesso geral
    // (EntityGrid injeta o campo condicionalmente) — pra todo mundo mais, o valor vem undefined
    // e o filtro é ignorado, já que o backend escopa Grupo pela publicacao da própria sessão de
    // qualquer forma. Sem esse filtro, o dropdown de Grupo mistura grupos de todos os tenants
    // quando quem está vinculando tem permiteacessogeral.
    filtro: (contexto) => ({
      publicacao: { constraints: [{ value: contexto.state.model.publicacao?.value, matchMode: 'equals' }] },
    }),
  },
  token: { exibir: 'main.usuariogrupo.token', visivel: false, largura: '20rem' },
  validopor: { exibir: 'main.usuariogrupo.validopor', visivel: false, tipo: 'numeric', keyfilter: 'num' },
};

const renderers = {
  usuario: { entidade: Usuario, template: (rowData) => rowData.usuario?.nome || rowData.usuario?.id || '' },
  grupo: { entidade: Grupo, template: (rowData) => rowData.grupo?.nome || rowData.grupo?.id || '' },
};

class UsuarioGrupoFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.usuariogrupo.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 md:col-6 mt-3"><ModelDropDown model={model.usuario} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelDropDown model={model.grupo} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.token} contexto={contexto} /></div>
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.validopor} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class UsuarioGrupoTemplate extends Component {
  render() {
    return (
      <RelatedEntityGrid
        entidade={UsuarioGrupo}
        model={model}
        identidade="main.usuariogrupo"
        icone="pi-link"
        permissoes={this.props.permissoes}
        storageKey="dt-usuariogrupos"
        processos={[]}
        relacionados={[]}
        renderers={renderers}
        configuracao={this.props.configuracao}
        formulario={(m, ctx) => <UsuarioGrupoFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default UsuarioGrupoTemplate;
